import React, { useEffect } from 'react';
import "./ServicePage.css";
import Image1 from "../../assets/APi.png"
import Image2 from "../../assets/Web.png"
import Image3 from "../../assets/design.png"
import Aos from 'aos';
import 'aos/dist/aos.css'

const data = [
  {
    id: 1,
    image: Image1,
    title: "API Development",
    description:
      "API development with Spring Boot.",
  },
  {
    id: 2,
    image: Image2,
    title: "Web Development",
    description:
      "HTML, CSS, and JavaScript , React, Bootstrap",
  },
  {
    id: 3,
    image: Image3,
    title: "Graphic Design",
    description:
      "Photoshop, Illustrator, Canva",
  },
];

const ServicePage = () => {
  useEffect(() => {
    Aos.init({duration: 100,  once: true, easing: "ease-in-out" });

  },[])
  return (
   <section className="services container section dark:bg-gray-800" id='services'>
    <h2 className="section__title dark:text-white">Services</h2>
    <div className="services__container grid">
      {data.map(({id,image,title,description})=>{
        return (
          <div className="services__card" key={id} data-aos = "flip-left" data-aos-anchor-placement="center-bottom">
            <img src={image} alt="" className="services__img" />
            <h3 className="services__title">{title}</h3>
            <p className="section__description">{description}</p>

          </div>
        );
      })}
    </div>


   </section>
  )
}

export default ServicePage;